/** Resolution of a trend chart's buckets: weeks when the range is under two calendar months, otherwise months. */
export enum PeriodBucketKind {
  Week = 'Week',
  Month = 'Month'
}
